var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 640",
    style: {
      enableBackground: "new 0 0 512 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,149.1V95.3c-15.8,3.4-29.8,22.7-38.3,50.1C112.7,147.6,125.5,148.8,138.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.8,134c-14.1-16.8-33.1-29.3-54.8-35.3c10,10.3,18.3,25.7,23.9,44.6C207.6,141,217.9,137.8,227.8,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.2,209.7h-46.7v40.7c13.9,0.3,27.7,1.6,40.9,4C192.8,240.8,194.9,225.7,195.2,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.6,95.3v53.8c13-0.3,25.8-1.5,38.3-3.7C178.4,118,164.4,98.7,148.6,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.8,264.1c-12.4-2.2-25.3-3.5-38.3-3.7v53.8C164.4,310.8,178.4,291.5,186.8,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.5,155c-13.3,2.4-27,3.8-40.9,4v40.7h46.7C194.9,183.8,192.8,168.6,189.5,155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,266.1c-10.7,2.4-21.1,5.5-30.9,9.3c14.1,16.8,33.1,29.3,54.8,35.3C104.2,300.5,95.9,285,90.3,266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,153c-12-2.7-23.6-6.3-34.6-10.7c-11.4,16.5-18.4,36.2-19.4,57.5h48.2C82.2,183,84.2,167.2,87.7,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,209.7H91.9c0.4,15.9,2.4,31.1,5.7,44.7c13.3-2.4,27-3.8,40.9-4v-40.7H138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.2,98.7c-21.7,6-40.7,18.5-54.8,35.3c9.8,3.8,20.2,6.9,30.9,9.3C95.9,124.4,104.2,109,114.2,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,209.7H33.7c1,21.3,8,41,19.4,57.5c11-4.4,22.6-8,34.6-10.7C84.2,242.3,82.2,226.5,81.9,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,314.2v-53.8c-13,0.3-25.8,1.5-38.3,3.7C108.7,291.5,122.7,310.8,138.6,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,159.1c-13.9-0.3-27.7-1.6-40.9-4c-3.3,13.6-5.4,28.8-5.7,44.7h46.7L138.6,159.1L138.6,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.9,444.7c-25.3,0-49.2-4.1-67.2-11.7c-8.4-3.5-15.2-7.6-20.1-12.1v30.3c0,15.8,35.9,33.5,87.4,33.5 s87.4-17.6,87.4-33.5v-30.3c-5,4.5-11.7,8.6-20.1,12.1C440.1,440.6,416.3,444.7,390.9,444.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.5,313.4l-0.1,0.1c-0.6,0.5-1.2,1-1.9,1.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.6,0.5-1.3,0.9-2,1.4 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.7,0.5-1.4,0.9-2.2,1.4c-0.1,0-0.1,0.1-0.2,0.1c-0.7,0.4-1.5,0.9-2.3,1.3c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.8,0.4-1.6,0.9-2.4,1.3c-0.2,0.1-0.3,0.2-0.5,0.2c-0.8,0.4-1.7,0.8-2.5,1.2c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.9,0.4-1.8,0.8-2.8,1.2c-18,7.5-41.9,11.7-67.2,11.7s-49.2-4.1-67.2-11.7c-1-0.4-1.9-0.8-2.8-1.2c-0.1-0.1-0.3-0.1-0.4-0.2 c-0.9-0.4-1.7-0.8-2.5-1.2c-0.2-0.1-0.3-0.2-0.5-0.2c-0.8-0.4-1.6-0.8-2.4-1.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.8-0.4-1.5-0.9-2.3-1.3c-0.1,0-0.1-0.1-0.2-0.1c-0.7-0.5-1.5-0.9-2.2-1.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.7-0.5-1.3-0.9-2-1.4 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.6-0.5-1.3-1-1.9-1.5l-0.1-0.1c-0.6-0.5-1.1-1-1.7-1.5c0,0-0.1-0.1-0.2-0.1v35.9 c0,15.8,35.9,33.5,87.4,33.5s87.4-17.6,87.4-33.5v-35.9l-0.1,0.1C477.6,312.5,477.1,313,476.5,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.9,391.2c-25.3,0-49.2-4.1-67.2-11.7c-8.4-3.5-15.2-7.6-20.1-12.1v33.8c0,15.8,35.9,33.5,87.4,33.5 s87.4-17.6,87.4-33.5v-33.8c-5,4.5-11.7,8.6-20.1,12.1C440.1,387.1,416.3,391.2,390.9,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.6,292.1c0,15.8,35.9,33.5,87.4,33.5s87.4-17.6,87.4-33.5s-35.9-33.5-87.4-33.5 C339.4,258.6,303.6,276.3,303.6,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.4,209.7h-48.2c-0.3,16.8-2.4,32.5-5.8,46.7c12,2.7,23.6,6.3,34.6,10.7 C245.5,250.7,252.5,231,253.4,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.9,494.7c-25.3,0-49.2-4.1-67.2-11.7c-8.4-3.5-15.2-7.6-20.1-12.1v40.4c0,0.1,0,0.2,0,0.2 c0.5,16,35.7,33.2,87.4,33.2s86.9-17.2,87.4-33.2c0-0.1,0-0.2,0-0.2v-40.4c-5,4.5-11.7,8.6-20.1,12.1 C440.1,490.6,416.3,494.7,390.9,494.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.2,199.7h48.2c-1-21.3-8-41-19.4-57.5c-11,4.4-22.6,8-34.6,10.7C202.9,167.2,204.9,183,205.2,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.9,310.7c21.7-6,40.7-18.5,54.8-35.3c-9.8-3.8-20.2-6.9-30.9-9.3C191.2,285,182.9,300.5,172.9,310.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.6,187.7l-11.5-11.5c-2-2-5.1-2-7.1,0s-2,5.1,0,7.1l20,20c0.2,0.2,0.5,0.4,0.8,0.6 c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.3,0.1,0.5,0.2c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.1,1,0.1 c0.3,0,0.7,0,1-0.1c0.1,0,0.3-0.1,0.4-0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.3-0.1,0.4-0.2 c0.3-0.2,0.5-0.4,0.8-0.6l20-20c2-2,2-5.1,0-7.1s-5.1-2-7.1,0l-11.5,11.5v-47.9c0-2.8-2.2-5-5-5h-130c-2.8,0-5,2.2-5,5 s2.2,5,5,5h125L413.6,187.7L413.6,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.6,444.7h-125v-42.9l11.5,11.5c1,1,2.3,1.5,3.5,1.5c1.3,0,2.6-0.5,3.5-1.5c2-2,2-5.1,0-7.1l-20-20 c-0.2-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1,0-0.3-0.1-0.4-0.1 c-0.6-0.1-1.3-0.1-2,0c-0.1,0-0.3,0.1-0.4,0.1c-0.2,0-0.3,0.1-0.5,0.2s-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.3,0.2-0.5,0.4-0.8,0.6l-20,20c-2,2-2,5.1,0,7.1s5.1,2,7.1,0l11.5-11.5v47.9c0,2.8,2.2,5,5,5h130c2.8,0,5-2.2,5-5 S261.3,444.7,258.6,444.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEws);
export default __webpack_public_path__ + "static/media/ews.e7b0fb194f9b7c9a5c0af836d3b05163.svg";
export { ForwardRef as ReactComponent };